let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kcnqS")).then(() => parcelRequire('4n6tJ'));